import React, { FC } from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { ArticlePreview } from '../../../../../../shared/types';
import RelatedGuidesItem from './RelatedGuidesItem';
import './index.scss';

const RelatedGuides: FC<{ relatedGuides: ArticlePreview[] }> = ({ relatedGuides }) => (
  <div className="related-guides">
    <h2>
      <I18n k="fiverr_guides.related_guides.label" />
    </h2>
    <div className="flex-wrapper">
      {relatedGuides.map((article, index) => (
        <RelatedGuidesItem key={index} article={article} />
      ))}
    </div>
  </div>
);

export default RelatedGuides;
